module.exports = {
  name: 'larkplayer-campaigns',
  cloundFront: {
    cdn_path: 'https://s.nxtpen.com', // CNAMES
    distribution_id: 'EJ499BTUXDLBW',
  },
  sensor: {
    server_url: 'https://w.gdflpr.com/sa?project=larkplayer',
    // debug 地址
    debug_server_url:
      'https://debuger.larkplayerapp.com/debug?project=larkplayer',
  },
}
